import apiClient from '@/shared/api/client';
import { ApiResponse } from '@/shared/api/types';

export interface PracticeSettings {
  id: string;
  name: string;
  slug: string;
  /** Industry — agency-set in Command Center, read-only here. Defaults to 'dental'. */
  vertical?: string;
  specialty?: string;
  phone?: string;
  website?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  status: string;
}

export const settingsApi = {
  getPractice: async (): Promise<ApiResponse<PracticeSettings>> => {
    const response = await apiClient.get<ApiResponse<PracticeSettings>>('/settings/practice');
    return response.data;
  },

  updatePractice: async (data: Partial<PracticeSettings>): Promise<ApiResponse<PracticeSettings>> => {
    const response = await apiClient.put<ApiResponse<PracticeSettings>>('/settings/practice', data);
    return response.data;
  },
};
